import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";

import image1 from "../Assets/Images/BG06.jpeg";
import image2 from "../Assets/Images/BG02.jpeg";
import image3 from "../Assets/Images/BG03.jpeg";
import image4 from "../Assets/Images/BG04.jpeg";
import image5 from "../Assets/Images/BG05.jpeg";
import image7 from "../Assets/Images/BG07.jpeg";
import image8 from "../Assets/Images/BG08.jpeg";
import image9 from "../Assets/Images/BG09.jpeg";
import image10 from "../Assets/Images/BG10.jpeg";

const images = [image7, image2, image3, image4, image5, image1, image8, image9, image10];

export default function BackgroundSlider() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // Start fading to black
      setTimeout(() => {
        setCurrentImageIndex((prev) => (prev + 1) % images.length); // Change image
        setFade(true); // Fade back in
      }, 2000); // Black fade duration (2s)
    }, 15000); // Change image every 15 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        position: "fixed",
        width: "100%",
        height: "100vh",
        overflow: "hidden",
        top: 0,
        left: 0,
        zIndex: -1,
      }}
    >
      {/* Black fade transition */}
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          backgroundColor: "black",
          opacity: fade ? 0 : 1,
          transition: "opacity 2s ease-in-out",
          zIndex: 2,
        }}
      />

      {/* Background Image */}
      <Box
        component="img"
        src={images[currentImageIndex]}
        alt="Background"
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          position: "absolute",
        }}
      />

      {/* Overlay */}
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark overlay for contrast
          zIndex: 1,
        }}
      />
    </Box>
  );
}
